import { Component, OnInit } from "@angular/core"
import { Store } from "@ngrx/store";
import { AppState } from "@store/app-state";
import { ModalService } from "@services/modal";
import { WorkshopsStore } from "@store/workshops";
import { ConstantsStore } from "@store/constants"; import { Workshop } from "@models/workshop";
import { Campus } from "@models/campus";
import { Course } from "@models/course";
import { Window } from "@models/window";
import { Observable } from "rxjs/Observable";
import { UPDATE_WORKSHOP } from "@reducers/workshops";
import { CompleterData, CompleterService, CompleterItem } from "ng2-completer";

@Component({
  selector: "workshop-campus-form",
  templateUrl: "workshop-campus-form.pug",
})
export class WorkshopCampusFormComponent implements OnInit {

  public workshopsStore: Observable<WorkshopsStore>
  public constantsStore: Observable<ConstantsStore>

  public workshop: Workshop
  public campus: Campus
  public courses: Course[]

  public courseSearchStr: string
  public courseCompleter: CompleterData

  public newWindow: Window = new Window()
  public isNewWindowFormVisible: boolean = false

  constructor(
    public store: Store<AppState>,
    private modalService: ModalService,
    private completerService: CompleterService,
  ) {}

  ngOnInit() {
    this.workshopsStore = this.store.select("workshopsReducer")
    this.constantsStore = this.store.select("constantsReducer")

    this.workshopsStore.subscribe((s: WorkshopsStore) => {
      this.workshop     = s.activeWorkshop
      this.campus       = s.activeCampus
    })

    this.constantsStore.subscribe((s: ConstantsStore) => {
      this.courses = s.constants.courses
    })

    this.newWindow.setStandardLunchtimes()
    this.newWindow.campusId   = this.campus.id
    this.newWindow.workshopId = this.workshop.id

    this.courseCompleter =
      this.completerService.local(this.courses, "humanised, code, name", "humanised")
  }

  windowsForCampus(): Window[] {
    return this.workshop.windows.filter((w: Window) => {
      return w.campus.id == this.campus.id
    })
  }

  submittedNewWindow(window: Window) {
    this.workshop.windows.push(window)
    this.store.dispatch({ type: UPDATE_WORKSHOP, payload: this.workshop })
    this.close()
  }

  submittedExistingWindow(window: Window) {
    this.store.dispatch({ type: UPDATE_WORKSHOP, payload: this.workshop })
    window.isEditing = false
    this.close()
  }

  closedEditWindowForm(window: Window) {
    window.isEditing = false
  }

  selectedCourse(e: CompleterItem) {
    if (e && e.originalObject) {
      this.workshop.courseIds.push((e.originalObject as Course).id)
      this.store.dispatch({ type: UPDATE_WORKSHOP, payload: this.workshop })
      this.courseSearchStr = ""
    }
  }

  clickedNewWindow() {
    this.isNewWindowFormVisible = true
  }

  clickedCloseNewWindowForm() {
    this.isNewWindowFormVisible = false
  }

  clickedEditWindow(window: Window) {
    window.isEditing = true
  }

  clickedRemoveCourse(course: Course) {
    course.isConfirmingRemove = true
  }
  
  clickedConfirmRemoveCourse(course: Course) {
    course.isConfirmingRemove = false
    this.workshop.courseIds =
      this.workshop.courseIds.filter((cId: number) => cId != course.id)

    this.store.dispatch({ type: UPDATE_WORKSHOP, payload: this.workshop })
  }

  clickedCancelRemoveCourse(course: Course) {
    course.isConfirmingRemove = false
  }

  close() {
    this.modalService.closeModal()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/workshop-campus-form.ts